module.exports = __webpack_public_path__ + "resource/img/dangerous-icon.b3a87a88.png";